var map = {
	"./de/mecha-btn.png": "zjeO",
	"./en/mecha-btn.png": "Mg4+",
	"./es/mecha-btn.png": "fjfd",
	"./fr/mecha-btn.png": "aC2B",
	"./ja/mecha-btn.png": "SmJ/",
	"./ko/mecha-btn.png": "ovZD",
	"./pt/mecha-btn.png": "JnWi",
	"./ru/mecha-btn.png": "1R0T",
	"./tc/mecha-btn.png": "33cQ",
	"./th/mecha-btn.png": "icKY"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rUGO";